import React from "react";

import ImageComponent from "../../common/ImageComponent";
import ActivitySource from "../../journal/timeslots/ActivitySource";

export default function IntegrationSourceIcon(props) {
  const { data } = props;

  const elementIcon = data.element?.icon;

  return (
    <>
      {elementIcon ? (
        <ImageComponent
          icon={elementIcon}
          style={{
            width: 20,
            height: 20,
          }}
        />
      ) : (
        <ActivitySource
          {...props}
          source={data.source}
          width={20}
          height={20}
        />
      )}
    </>
  );
}
